import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";
import { STAR } from "./shapes";

export function LoyaltyIllustration(props: IllustrationProps) {
  return (
    <Frame {...props} tone="accent">
      <path d={STAR} transform="translate(28 96)" fill={c.a400} />
      <path d={STAR} transform="translate(132 96)" fill={c.a400} />
      <rect x="44" y="76" width="72" height="54" rx="8" fill={c.p500} />
      <rect x="38" y="60" width="84" height="22" rx="8" fill={c.p600} />
      <rect x="74" y="60" width="12" height="70" fill={c.a400} />
      <path d="M80 60C58 56 52 34 66 32C76 30 80 46 80 60Z" fill={c.a500} />
      <path d="M80 60C102 56 108 34 94 32C84 30 80 46 80 60Z" fill={c.a500} />
    </Frame>
  );
}
